var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Comment',{attrs:{"query":{ enquiryType: 1 },"back":"/emergencyOpenInquiry"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }